/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, { Component } from 'react';
import './loader.scss'

export default class Loader extends Component {

    render() {
        if(this.props.display){
            return <div className="loaderBackground">
                     <div className="loader" ></div>
                   </div>
        } else{
            return <div/>
        }
    }
}
